import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from '@apollo/client';
import { listUsersByTeamOne, listNotifications } from '../../../graphql/queries';
import { createNotification } from '../../../graphql/mutations';
import './NotificationSchedule.css';
import { fetchAuthSession } from 'aws-amplify/auth';

const NotificationSchedule = ({ NameLogin, isOpen, onClose, idSupervisor }) => {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [selectedUsers, setSelectedUsers] = useState([]);
    const { data: userData } = useQuery(listUsersByTeamOne);
    const [isAdding, setIsAdding] = useState(false);
    const [addNotification] = useMutation(createNotification, {
        refetchQueries: [{ query: listNotifications, variables: { limit: 100 } }]
    });


    //listUserFixes 
    const navigatorOptions = userData?.listUserFixes?.items
        ?.filter((u) => u && u.first_name && u.last_name)
        ?.map((u) => ({
            id: u.id,
            thc_email_id: u.thc_email_id,
            name: `${u.first_name.charAt(0).toUpperCase() + u.first_name.slice(1).toLowerCase()} 
       ${u.last_name.charAt(0).toUpperCase() + u.last_name.slice(1).toLowerCase()}`
        }))
        ?.sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })) || [];


    const handleUserChange = (e) => {
        const { value, checked } = e.target;
        const userData = JSON.parse(value); // ✅ Convertir string JSON a objeto { email, id }

        if (value === "all") {
            handleAllUsers(checked);
        } else {
            setSelectedUsers((prev) =>
                checked ? [...prev, userData] : prev.filter(user => user.email !== userData.email)
            );
        }
    };

    const handleAllUsers = (checked) => {
        if (checked) {
            setSelectedUsers(navigatorOptions.map(user => ({ email: user.thc_email_id, id: user.id }))); // ✅ Seleccionar todos
        } else {
            setSelectedUsers([]); // ✅ Deseleccionar todos
        }
    };


    const handleSend = async () => {

        setIsAdding(true);

        if ((!selectedUsers || selectedUsers.length === 0) || !startDate || !endDate) {
            alert("⚠️ You must select at least one user and a date range.");
            setIsAdding(false);
            return;
        }

        //Send Email
        for (const user of selectedUsers) {
            console.log("📩 Sending email to:", user.email);
            console.log("🆔 User ID:", user.id);
            try {

                const employeeUsername = user.email?.split("@")[0];
                console.log("Extracted Username:", employeeUsername);

                if (!user.email) {
                    console.error("❌ No email found for user.");
                    return;
                }

                console.log("Employee Email", user.email);

                const emailContent = {
                    to: user.email,
                    subject: `You have scheduled notifications from  ${startDate} to ${endDate}`,
                    body: `
                <html>
            <body style="font-family: Arial, sans-serif; background-color: #f9f9f9; margin: 0; padding: 0;">
              <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f9f9f9; padding: 20px 0;">
                <tr>
                  <td align="center">
                    <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                      <tr>
                        <td align="center" style="background-color:rgb(37, 59, 146); color: #ffffff; padding: 20px; border-top-left-radius: 8px; border-top-right-radius: 8px;">
                          <h1 style="margin: 0; font-size: 24px;">Work Scheduled Notification</h1>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 20px; color: #333333; line-height: 1.6;">
                          <p style="font-size: 16px; margin: 0 0 20px;">Dear <strong>${employeeUsername}</strong>,</p>
                          <p style="font-size: 16px; margin: 0 0 20px;"> We are pleased to inform you that you have an update to your weekly schedule from the <strong>${startDate} to ${endDate}</strong>.</p>
            
                          <p style="font-size: 16px; margin: 0 0 20px;">If you have any further questions or need additional support, please don’t hesitate to reach out.</p>
                        </td>
                      </tr>
                      <tr>
                        <td align="center" style="padding: 20px;">
                          <a href="https://compasshealthcollaborative.org/work-schedules" 
                             style="display: inline-block; padding: 12px 25px; font-size: 16px; color: #ffffff; background-color:rgb(37, 59, 146); text-decoration: none; border-radius: 4px;">
                            View Work Schedules
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 20px; font-size: 14px; color: #777777; text-align: center;">
                          <p style="margin: 0;">This is an automated email. Please do not reply.</p>
                          <p style="margin: 0;">&copy; 2025 Compass Health Collaborative. All Rights Reserved.</p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </body>
          </html>
          
                `
                };

                console.log("Sending completion notification to employee:", user.email);
                await invokeLambdaFunction(emailContent);
                console.log("Notification sent to employee.");
                console.log("✅ Notification sent to employee.");
            } catch (error) {
                console.error("❌ Error sending notification:", error);
            }

            //Send Notification Compass
            // Function to get a date 1 month after the given date
            const getExpirationDate = (startDate) => {
                const date = new Date(startDate);
                date.setMonth(date.getMonth() + 1);
                return date.toISOString();
            };

            // Generate the expiration date
            const timestampNow = new Date().toISOString();
            const expirationDate = getExpirationDate(timestampNow);

            //generateRelatedId
            const generateRelatedId = (user, idSupervisor, timestampNow) => {
                const data = `${user}-${idSupervisor}-${timestampNow}`;

                // ✅ Convert string to a simple hash number
                let hash = 0;
                for (let i = 0; i < data.length; i++) {
                    hash = (hash << 5) - hash + data.charCodeAt(i);
                    hash |= 0; // Convert to 32-bit integer
                }

                // ✅ Convert hash to Base36 and extract last 6 characters
                return Math.abs(hash).toString(36).toUpperCase().slice(-6);
            };


            const notificationData = {
                type: 'Work Schedule',
                userID: user.id,
                supervisorID: idSupervisor,
                adminID: 'null',
                relatedId: generateRelatedId(user.id, idSupervisor, timestampNow),
                status: [],
                active: true,
                creationDate: timestampNow,
                expirationDate: expirationDate,
                userId: user.id,
                notes: "The shift was create or updated",
                createdBy: NameLogin,
            };

            await addNotification({ variables: { input: notificationData } });
        }

        setIsAdding(false);
        onClose();
    };

    const invokeLambdaFunction = async (emailData) => {
        const url = "https://buykqjzjjh.execute-api.us-east-2.amazonaws.com/compassdev/sendemail";

        try {
            // Obtener token de autenticación (si es necesario)
            const session = await fetchAuthSession();
            if (!session || !session.tokens || !session.tokens.idToken) {
                throw new Error("User is not authenticated or token is missing.");
            }
            const idToken = session.tokens.idToken.toString();

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${idToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(emailData),
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to send email. Error: ${errorText}`);
            }

            const data = await response.json();
            console.log("Lambda function response:", data);
            alert("The notification sent successfully!");
        } catch (error) {
            console.error("Error invoking Lambda:", error.message);
            alert("Failed to send notification email.");
        }
    };

    return (
        <div className={`modal-overlay ${isOpen ? "active" : ""}`} onClick={(e) => {onClose()}}>
            <div className="notification-modal" onClick={(e) => e.stopPropagation()}>
                <h3>📢 Schedule Notification</h3>

                <label>👤 Select Employe(s):</label>
                <div className="user-checkboxes">
                    <label className="all-users">
                        <input
                            type="checkbox"
                            value="all"
                            checked={selectedUsers.length === navigatorOptions.length}
                            onChange={handleAllUsers}
                        />
                        All
                    </label>

                    {navigatorOptions.map((user) => (
                        <label key={user.thc_email_id}>
                            <input
                                type="checkbox"
                                value={JSON.stringify({ email: user.thc_email_id, id: user.id })} // ✅ Guardar email + ID en value
                                checked={selectedUsers.some(u => u.email === user.thc_email_id)}
                                onChange={handleUserChange}
                            />
                            {user.name}
                        </label>
                    ))}
                </div>



                <label>📅 Start Date::</label>
                <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />

                <label>📅 End Date:</label>
                <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />

                <div className="button-group">
                    <button className="send-btn" onClick={handleSend} disabled={isAdding}> {isAdding ? 'Sending...' : '🔔 Send Notification'}</button>
                    <button className="send-btn" onClick={onClose} >Close</button>
                </div>
            </div>
        </div>
    );
};

export default NotificationSchedule;
